import { Platform } from 'react-native';
import { tv } from '@/common/theme/tv.config';

export const styles = {
  root: tv({
    base: 'z-[1]',
  }),
  wrapper: tv({
    base: 'flex h-[6.4rem] w-full flex-row items-center rounded-md border-[0.1rem] border-neutral20 bg-neutral10 px-md hover:border-neutral30',
    variants: {
      focused: {
        true: 'border-neutral30',
      },
      disabled: {
        true: 'cursor-not-allowed border-neutral20 bg-neutral20 hover:border-neutral20',
      },
      inline: {
        true: 'h-[4rem]',
      },
      noPadding: {
        true: 'p-0',
      },
      withError: {
        true: 'border-systemError hover:border-systemError',
      },
    },
    compoundVariants: [
      {
        focused: true,
        withError: true,
        className: 'border-[0.1rem] border-systemError',
      },
    ],
  }),
  inputWrapper: 'relative flex-1 h-full overflow-hidden',
  labelWrapper: tv({
    base: [
      'cursor-inherit absolute left-0 top-1/2 max-w-full -translate-y-1/2 transform',
      Platform.OS === 'web' ? 'transition-all' : '',
    ],
    variants: {
      align: {
        top: 'top-[2.4rem] scale-[1]',
        center: '',
      },
      active: {
        true: 'top-[1rem] max-w-[114%] translate-y-0 scale-[0.875]',
      },
    },
  }),
  label: 'block text-ellipsis whitespace-nowrap overflow-clip',
  input: tv({
    base: 'relative h-full w-full justify-center text-ellipsis px-0 pb-[1rem] pt-[3rem] font-F37Bold text-md text-neutral30',
    variants: {
      align: {
        left: '',
        center: 'text-center',
        right: 'text-right',
      },
      inline: {
        true: 'px-0 py-[0.4rem]',
      },
      disabled: {
        true: 'text-neutral20',
      },
    },
  }),
  hint: tv({
    base: 'mt-sm',
    variants: {
      invalid: {
        true: 'text-systemError',
      },
    },
  }),
};
